import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Sidebar({ header, action, children, footer }) {
    return (_jsxs("nav", { "aria-label": "Main navigation", "data-sidebar": true, style: {
            display: 'flex',
            flexDirection: 'column',
            width: 'var(--sidebar-width, 240px)',
            /* height set by [data-sidebar] rule in direction-b.css (100vh → 100svh fallback) */
            background: 'var(--surface-elevated)',
            borderRight: '1px solid var(--border)',
            position: 'relative',
        }, children: [header ? (_jsx("div", { "data-sidebar-header": true, style: { flexShrink: 0, padding: 'var(--sp-3)' }, children: header })) : null, action ? (_jsx("div", { "data-sidebar-action": true, style: { flexShrink: 0 }, children: action })) : null, _jsx("div", { "data-sidebar-body": true, style: {
                    flex: 1,
                    overflowY: 'auto',
                    overscrollBehavior: 'contain',
                    paddingTop: 'var(--sp-2)',
                    paddingBottom: 'var(--sp-2)',
                }, children: children }), footer ? (_jsx("div", { "data-sidebar-footer": true, style: {
                    flexShrink: 0,
                    borderTop: '1px solid var(--border)',
                    padding: 'var(--sp-3)',
                }, children: footer })) : null] }));
}
//# sourceMappingURL=Sidebar.js.map